import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { interval, map, Observable, shareReplay } from 'rxjs';

import { LoadingService } from './services/loading.service';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';
import { AlertConfirmService } from './services/alert-confirm.service';
import { AlertConfirmComponent } from './common/alert-confirm/alert-confirm.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, CommonModule, AlertConfirmComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  fullscreen = false;
  user: any = {};
  sPanel: string = "";

  // Emit a new Date object every 1 second [24]
  currentTime$: Observable<Date> = interval(1000).pipe(
    map(() => new Date()),
    shareReplay(1)
  );

  constructor(
    public loading: LoadingService, 
    public auth: AuthService, 
    public alertService: AlertConfirmService, 
    public dataService: DataService
  ) {
    //
  }

  ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }
  }

}
